














































































import Vue from 'vue';
import InlineSVG from 'vue-inline-svg';
import TIcons from '@/types/TIcons';
import { IBar } from '@/common/interfaces/announcement-bar.interface';

interface IAnnouncementBarTimer {
  hours: number;
  minutes: number;
  seconds: number;
}

interface IBarComponent {
  arrowIcon: string;
  infoIIcon: string;
}

export default Vue.extend({
  name: `Bar`,
  components: { InlineSVG },
  data(): IBarComponent {
    return {
      arrowIcon: TIcons.arrow,
      infoIIcon: TIcons.announcementBarInfoI,
    };
  },
  computed: {
    contentStyle(): string {
      return `color: ${this.bar.textColor};`;
    },
    highlightedContentStyle(): string {
      return `color: ${this.bar.highlightTextColor};`;
    },
    infoBackgroundStyle(): string {
      return `background-color: ${this.bar.infoBackgroundColor};`;
    },
    infoContentStyle(): string {
      return `color: ${this.bar.infoTextColor};`;
    },
    linkStyle(): string {
      return `color: ${this.bar.linkColor}`;
    },
  },
  props: {
    active: {
      default: false,
      type: Boolean,
    },
    bar: {
      required: true,
      type: Object as () => IBar,
    },
    link: {
      default: ``,
      type: String,
    },
    timer: {
      required: true,
      type: Object as () => IAnnouncementBarTimer,
    },
  },
  methods: {
    getTimerString(value: number): string {
      return value < 10 ? `0${value}` : `${value}`;
    },
  },
});
